<template>
  <div class="thousand_layout">
    <div class="right_box tab_width">
      <div class="right_box_title">
        <h2>{{$t('base.recentlyViewed')}}</h2>
        <div @click="ClearList()" v-if="!nofind">{{$t('base.clearAll')}}</div>
      </div>
      <el-skeleton :count="12" animated class="skull" :loading="loading">
          <template slot="template">
            <list-skeleton />
           <!--  <div class="skullList">
              <el-skeleton-item variant="image" class="skullImg" />
              <div>
                  <el-skeleton-item variant="text" />
                  <el-skeleton-item variant="text" />
                  <el-skeleton-item variant="text" class="skullTitle"/>
                  <div class="skullPrice">
                  <el-skeleton-item variant="text" class="skullTitle"/>
                  </div>
                <div class="skullBids">
                  <el-skeleton-item variant="text" class="skullTitle"/>
                  <el-skeleton-item variant="text" class="skullTitle"/>
                </div>
              </div>
            </div> -->
          </template>
          <template>
            <goods-list class="" :list="list" type='recently' />
            <!-- <goods-list class="thousand_layout" :StatusNum="Status" :list="list" type="search" /> -->
          </template>
        </el-skeleton>
      <!-- <f-z-f class="notfind" title="" v-if="nofind"/> -->
      <!-- <list-pagination class=""  :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex'  v-if="!nofind"/> -->
            <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-if="resultTpye==1" />
            <f-z-f class="notfind" title="" :text="$t('base.pagefault')" v-else />
    </div>
  </div>
</template>

<script>
/* 模拟假数据 */

import qs from 'qs'
import GoodsList from '@/components/list/goods'
import ListPagination from '@/components/listpagination'
import FZF from "@/components/404.vue";
import NOTN from "@/components/notnull.vue";
import ListSkeleton from "@/components/skeleton.vue";

export default {
  name: 'tabslist',
  components: {GoodsList,ListPagination,FZF,NOTN,ListSkeleton},
  data () {
    return {
      loading:false,
      pi:1,
      ps:120,
      TotalCount: 0,
      list:'',
      nofind:false,
      resultTpye: '',
    }
  },
  props: {
    userInfo: {}
  },
  mounted() {
  },
  created() {
    this.GetTourHistory()
  },
  methods: {
    /**
     * 获取用户旅游历史记录
     * @description 通过用户ID和令牌获取旅游历史数据，包含分页功能
     * @method GetTourHistory
     * @returns {Promise} 返回包含旅游历史数据的Promise对象
     * - result: 请求结果状态码
     * - count: 记录总数
     * - data: 历史记录列表
     */
    GetTourHistory() {
      let that = this;
      this.loading=true;
      let data={operator_id:that.userInfo.MappingUserId,MemberId:that.userInfo.MappingUserId,token:that.userInfo.ChineseToken,PageIndex:that.pi,PageSize:that.ps}
      this.$get(this.$interface.GetTourHistory,data).then(res=>{
        //console.log(res)
        if(res.result!=0){
          that.TotalCount=res.count;
          that.list=res.data;
          that.loading=false
          if(res.count==0){
            this.nofind=true;
          }else{
            this.nofind=false
          }
        }else{
          this.nofind=true
          that.list = null;
          that.TotalCount = 0
          this.loading=false
        }
        this.resultTpye = res.result
      })
    },

    // 每页几条
    pageSize(val) {
      this.ps = val
      this.GetTourHistory();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.GetTourHistory();
    },
    /**
     * 清空最近浏览记录列表
     * 弹出确认框询问用户是否清空所有最近浏览记录
     * 确认后调用接口删除用户的浏览历史记录
     * 删除成功后重新获取浏览历史列表
     * @method ClearList
     */
    ClearList() {
      let that = this;
      this.$confirm(that.$t('alert.clearAllRecently'), that.$t('title.clearAll'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
        }).then(() => {
          let data={operator_id:that.userInfo.MappingUserId,MemberId:that.userInfo.MappingUserId,token:that.userInfo.ChineseToken,CommodityId:0}
          this.$post(this.$interface.DelTourHistory,qs.stringify(data)).then(res=>{
            this.GetTourHistory();
          })
          // console.log(data)
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });          
        });
      //this.list=[]
    }
  } 
} 
</script>

<style scoped>
@import "../../../static/css/usertabslist.css";
</style>



// WEBPACK FOOTER //
// src/pages/user/recently.vue